import ListItem from '../../blog/list/listItem';
import BlogItems from '../../../data/blogs';

const featuredProjects = () => {

    const blogItems = BlogItems.filter(item => item.featured === true && item.display === true);

    return (
        <section className="section-featured-blogs">
            <div className="blog">
                <div className="row u-margin-bottom-medium">
                    <h2 className="heading-secondary">
                        Featured Blogs
                    </h2>
                </div>
            
                <div className="row">
                {blogItems.map(item => (
                            <ListItem
                                key={ item.id }
                                item={ item }
                            />
                        ))}
                </div>
                
            </div>            
        </section>
    )
}

export default featuredProjects;